import {createAction, CustomStoreAddOn, on, RemoteCollectionStore, StoreBuilder} from "@softline/core";
import {Palette} from "../types/palette";
import {lastValueFrom} from "rxjs";
import {PaletteService} from "../services/palette-service";

type State = RemoteCollectionStore.State<Palette>;

const remoteCollectionStore = RemoteCollectionStore.create<Palette>();

const mutations = {
}

const getters = {
}

const actions = {
 loadPalatte: createAction<State, { idpalette: string }, Palette>('llrKommissionierung/actions/loadPalette'),
 palettenMengeUebernehmen: createAction<State, { idpalette: string, payload: Palette }, Palette>('llrKommissionierung/actions/palettenMengeUebernehmen')
}

const LlrKommissionierungPaletteStoreExtension: CustomStoreAddOn<State, typeof mutations, typeof getters, typeof actions> = {
  mutations,
  getters,
  actions,
  feature: {
    getters: [],
    actions: [
      on(actions.loadPalatte, async ({ params, injector, commit, featureName }) => {
        const service = injector.get(PaletteService);

        const result =  await lastValueFrom(service.loadPalette(params.idpalette));

        commit(featureName, remoteCollectionStore.mutations.addOrUpdate, result);

        return result;
      }),
      on(actions.palettenMengeUebernehmen, async ({ params, injector, commit, featureName }) => {
        const service = injector.get(PaletteService);

        const result =  await lastValueFrom(service.palettenMengeUebernehmen(params.idpalette, params.payload));

        commit(featureName, remoteCollectionStore.mutations.addOrUpdate, result);

        return result;
      })
    ],
    mutations: [
    ]
  },
}
export const LlrPalleteStore = new StoreBuilder(remoteCollectionStore)
  .add(LlrKommissionierungPaletteStoreExtension)
  .value
